import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { IRecinilliation } from './IRecinilliation';
import { reconcilliationService } from './reconcilliation-report.service';



@Component({
  selector: 'app-reconcilliation-report',
  templateUrl: './reconcilliation-report.component.html',
  styleUrls: ['./reconcilliation-report.component.scss']
})
export class ReconcilliationReportComponent implements OnInit {

  public afdeling : IRecinilliation[];
  p: any = {};
  constructor(private apiService: reconcilliationService) { }

  ngOnInit() {  
    this.getReport();  
  }

  getReport (){
    this.apiService.getReconcilliationData().subscribe(      
      res => {       
       this.afdeling = res.data;
      }
    );
  }
}

